import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '2px 6px 2px 10px',
    display: 'flex',
    alignItems: 'center',
    minWidth: 294,
    height: 34,
    boxSizing: 'border-box',
    borderRadius: 17,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.box.secondaryBorderColor}`,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    height: 28,
    '& fieldset': { border: 0 },
    '& input': { padding: '6px 10px 8px 0 !important', fontSize: 13 },
  },
  iconButton: {
    background: 'none',
    border: 'none',
    borderRadius: '50%',
    '& svg': { color: theme.palette.common.green },
  },
}));

const SearchInput = ({
  placeholder = '',
  handleSearch = (f) => f,
  className = '',
  params = {},
  getParam,
}) => {
  const { keyword } = params;
  const classes = useStyles();
  const { t } = useTranslation();
  const usePrevious = (value) => {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  };
  const prevParams = usePrevious(params);

  useEffect(() => {
    if (typeof prevParams !== 'undefined') {
      if (JSON.stringify(prevParams) !== JSON.stringify(params)) {
        if (
          (typeof prevParams.keyword !== 'undefined' ||
            typeof params.keyword !== 'undefined') &&
          prevParams.keyword !== params.keyword
        ) {
          handleSearch(keyword);
        }
      }
    }

    // eslint-disable-next-line
  }, [params]);

  return (
    <Paper component="div" className={`${classes.root} ${className}`}>
      <NewInput
        className={classes.input}
        placeholder={placeholder}
        type="filter"
        name="keyword"
        params={params}
        value={keyword}
        callBack={(newParams, name) => {
          let tempParams = { ...newParams };
          if (tempParams[name] === '') delete tempParams[name];
          getParam(tempParams, 'keyword');
        }}
      />
      <NewButton
        title={t('검색')}
        iconBtn
        icon="faSearch"
        disableRipple
        className={classes.iconButton}
      />
    </Paper>
  );
};

export default SearchInput;
